define('Digi.LoginRedirect.LoginRedirect.Model',
[
    'SCModel',
    'Utils'
],
function(
    SCModelModule,
    Utils
) {
    'use strict';

    var SCModel = SCModelModule.SCModel;

    function LoginRedirectModel (model, options) {
        SCModel.call(this, model, options);

        this.urlRoot = function urlRoot () {
            return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "Modules/LoginRedirect/SuiteScript2/Digi.LoginRedirect.LoginRedirect.Service.ss"
                ), true
            )
        }
    }

    LoginRedirectModel.prototype = Object.create(SCModel.prototype);
    LoginRedirectModel.prototype.constructor = LoginRedirectModel;

    return LoginRedirectModel;
});
